<template>
  <transition name="fade">
    <div class="modal-backdrop" v-on:click="close">
      <div class="modal" role="dialog" v-on:click.stop>
        <header id="modal-header">
          <slot name="header"></slot>
        </header>
        <section id="modal-content">
          <slot name="content"></slot>
        </section>
        <footer id="modal-footer">
          <button type="button" v-on:click="close" aria-label="Close modal">
            Cerrar
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "modal",
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../stylesheets/theme";
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.modal {
  background: #ffffff;
  box-shadow: 0px 5px 10px 0.5px #333;
  border-radius: 25px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  padding: 5%;
  width: max-content;
  max-width: 80%;
  z-index: 2;

  #modal-header,
  #modal-footer {
    display: flex;
    text-align: center;
    font-family: font(pFont);
    justify-content: center;
  }

  #modal-header {
    font-size: 3.5vh;
    color: color(dGray);
    line-height: 120%;
  }

  #modal-content {
    display: flex;
    flex-flow: column;
    justify-content: center;
    text-align: center;
  }

  #modal-footer {
    padding-top: 1vh;

    button {
      font-family: font(tFont);
      color: color(white);
      border-radius: 100px;
      padding: 5px 5vw;
      margin: 1vh 0;
      font-size: 2.5vh;
      letter-spacing: 2px;
      background-color: color(danger);
      border: none;
      font-weight: normal;
      cursor: pointer;

      &:hover {
        background-color: darken($color: color(danger), $amount: 10%);
      }

      &:focus {
        outline: none;
      }
    }
  }
}
</style>
